import { SearchType } from "../types/baseTypes";
import { getAundsV1Url } from "../utils/url";

export const getSearch = async ({
  keyword,
  postsPerPage,
  page,
}: {
  keyword: string;
  postsPerPage?: number;
  page?: number;
}): Promise<SearchType> => {
  const searchRes = await fetch(
    getAundsV1Url() +
      "/search/?keyword=" +
      keyword +
      dynamicParamUrl(postsPerPage, page),
  );
  return await searchRes.json();
};

export function dynamicParamUrl(postsPerPage?: number, page?: number) {
  let url;

  if (postsPerPage && page) {
    url = "&per_page=" + postsPerPage + "&page=" + page;
  } else {
    url = "";
  }

  return url;
}
